/* eslint-disable react-hooks/exhaustive-deps */
import useFetch from '@hooks/useFetch';

const useContestOnboardingPreference = (
  goalUID,
  options = { fallbackData: undefined }
) => {
  const key = 'v1/user/me/onboarding_preferences';
  const params = {
    goal_uid: goalUID
  };
  const {
    data: contestOnboardingPreferenceData,
    isValidating,
    ...rest
  } = useFetch(key, {}, { fallbackData: options.fallbackData, params });

  return {
    key,
    contestOnboardingPreferenceData,
    isValidating,
    ...rest
  };
};

export default useContestOnboardingPreference;
